import { SiteBackgroundGradient } from '@hostinger/builder-schema-validator';

export const getGradientCss = (gradient: SiteBackgroundGradient): string => {
	const gradientColors = gradient.colors.map((color) => color.value).join(', ');

	return `linear-gradient(${gradient.angle}deg, ${gradientColors})`;
};
